import { Column, Row } from '~components/table-view-v3';
import WorkerFocusAction from '~weekly-planner/components/WorkerFocusAction';

import ConflictAppointment from './ConflictAppointment';

const getConflictsColumns = (): Column[] => [
  {
    id: 'appointment',
    header: 'Appointment',
    type: 'custom',
    component: ConflictAppointment,
    componentProps: (row: Row) => ({
      date: row.date,
      start_time: row.start_time,
      client: row.client,
    }),
  },
  {
    id: 'worker',
    header: 'Worker',
    type: 'text',
    deriveValue: (row) => row.user?.full_name,
  },
  {
    id: 'conflict_type',
    header: 'Conflict',
    type: 'text',
  },
  {
    id: 'actions',
    header: '',
    type: 'custom',
    component: WorkerFocusAction,
    componentProps: (row: Row) => ({ userId: row.user?.id }),
  },
];

export default getConflictsColumns;
